// Exporting LoadableSkillsToProficientBanner component from
// loadable-banner.ts file in order to reduce clutter in developer's
// auto-complete suggestions.
import React from "react";

import type {PropsFor} from "@khanacademy/wonder-blocks-core";

type SkillsToProficientCourseBannerProps = PropsFor<
    typeof import("./course-banner.tsx").default
>;
type SkillsToProficientOverallBannerProps = PropsFor<
    typeof import("./overall-banner.tsx").default
>;

const LazySkillsToProficientCourseBanner = React.lazy(
    () => import("./course-banner.tsx"),
);
const LazySkillsToProficientOverallBanner = React.lazy(
    () => import("./overall-banner.tsx"),
);

// Consumers should import this instead of the
// SkillsToProficientCourseBanner component from course-banner.tsx.
export const SkillsToProficientCourseBanner = (
    props: SkillsToProficientCourseBannerProps,
) => (
    <React.Suspense fallback={null}>
        <LazySkillsToProficientCourseBanner {...props} />
    </React.Suspense>
);

// Consumers should import this instead of the
// SkillsToProficientOverallBanner component from overall-banner.tsx.
export const SkillsToProficientOverallBanner = (
    props: SkillsToProficientOverallBannerProps,
) => (
    <React.Suspense fallback={null}>
        <LazySkillsToProficientOverallBanner {...props} />
    </React.Suspense>
);
